<template>
  <div class="fill-height" :style="backgroundStyle()">
    <v-layout class="fill-height" align-center>
      <v-flex>
        <v-main>
          <v-fade-transition mode="out-in">
            <router-view />
          </v-fade-transition>
        </v-main>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  methods: {
    backgroundStyle: () => ({
      backgroundImage:
        "linear-gradient(to bottom, rgba(141, 191, 33, 0.75), rgba(118, 166, 46, 0.75))," +
        `url(${require("@/assets/bubble.svg")}`,
      backgroundSize: "cover",
      backgroundPosition: "center center"
    })
  }
};
</script>

